import { render, staticRenderFns } from "./ProjectStatisticWorkloadConfigModal.vue?vue&type=template&id=f2f64240&scoped=true"
import script from "./ProjectStatisticWorkloadConfigModal.vue?vue&type=script&lang=js"
export * from "./ProjectStatisticWorkloadConfigModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f64240",
  null
  
)

export default component.exports